import React from "react";
import Navbar from "../../components/navbar";
import "./style.scss";
import { useLocation } from "react-router-dom";
import RoundedBtn from "../../components/buttons/roundedBtn";

const MainLayout = ({ children, locationBtnText, hrLine = false, formTransparent, showLocationBtn, locationClick }) => {
  const location = useLocation();
  return (
    <div className="main__layout">
      <Navbar locationClick={locationClick} showLocationBtn={showLocationBtn} locationBtnText={locationBtnText} />
      {
        (location?.pathname === "/finish" || hrLine) && (
          <div className="hr__line"></div>
        )
      }
      {showLocationBtn ? (
          <div className="px-4 py-3 location__rounded__btn"><RoundedBtn
          onClick={locationClick}
          text={locationBtnText}
        /></div>
        ) : (
          ""
        )}

      <div className="form__section">
        <div style={formTransparent ? { backgroundColor: 'transparent' } : {}} className="form__box">{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
